// import { dateEnUS, dateZhCN, enUS, zhCN } from 'naive-ui';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import en from 'element-plus/dist/locale/en.mjs';

// 定义语言类型
type LangType = 'zh-CN' | 'en-US';

export const UILocales: Record<LangType, any> = {
  'zh-CN': zhCn,
  'en-US': en
};

// export const naiveDateLocales: Record<LangType, NDateLocale> = {
//   'zh-CN': dateZhCN,
//   'en-US': dateEnUS
// };
